import { Typography } from "@circle-react-shared/uikit/Typography";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useIsUnifiedInboxRoute } from "@circle-react/hooks/chatsV2/messaging/useIsUnifiedInboxRoute";

import { t } from "@/i18n-js/instance";

export const AiInboxTitle = () => {
  const isUnifiedInboxRoute = useIsUnifiedInboxRoute();

  return (
    <div
      className={classNames("flex h-14 items-center px-6 py-2", {
        "border-primary border-b": !isUnifiedInboxRoute,
      })}
    >
      <Typography.TitleSm weight="semibold">
        {t("settings_nav_v3.community_inbox.label")}
      </Typography.TitleSm>
    </div>
  );
};
